export const lightTheme = {
    backgroundColor: "#FFFFFF",
    textColor: "#FFD24C",
    primary: "#FFE69A",
    secondary: "#92B4EC"
};

export const darkTheme = {
    backgroundColor: "#E6E6E6",
    textColor: "#5C7AEA",
    primary: "#3D56B2",
    secondary: "#2D31FA"
};

export const partyTheme = {
    backgroundColor: "#D8E9A8",
    textColor: "#000000",
    primary: "#1E5128",
    secondary: "#4E9F3D"
};

// Placeholder Core 2025 theme; will be updated with exact PDF values
export const core2025Theme = {
    backgroundColor: "#FFFFFF",
    // Use a strong blue from secondary palette as UI accent
    textColor: "#274ea2",
    // Brand primary (navy)
    primary: "#18325b",
    // Brand secondary (orange)
    secondary: "#fbb03c",
    // Extended palette (from PDF) for charts/visuals
    accent2: "#6386c4",
    accent3: "#76cfe9"
};